/**
 * Strip html tags and truncate to 160 char
 */
export const CleanDescription = (description) => {
  description = description.replace(/<\/?[^>]+(>|$)/g, "");
  return shorten(description, 160);
}

const shorten = (str, maxLen, separator = ' ') => {
  if (str.length <= maxLen) return str;
  return str.slice(0, str.lastIndexOf(separator, maxLen));
}
